module.exports = __webpack_public_path__ + "img/basic-layout.2fb988dd.svg";